<div class="search-bar">
  <button
    type="button"
    class="search-bar__icon-btn"
    (click)="onSearch()"
    aria-label="Buscar"
  >
    <app-icon [icon]="searchIcon" [size]="18" />
  </button>
  <input
    #input
    type="search"
    class="search-bar__input"
    [placeholder]="placeholder()"
    [value]="query()"
    (input)="onInput($event)"
    (keydown)="onKeydown($event)"
    (focus)="onFocus()"
    (blur)="onBlur()"
    autocomplete="off"
  />
  @if (hasValue()) {
    <button
      type="button"
      class="search-bar__clear-btn"
      (click)="onClear()"
      aria-label="Limpiar búsqueda"
    >
      <app-icon [icon]="clearIcon" [size]="16" />
    </button>
  }
</div>
